import Typography from "@mui/material/Typography";
import {Grid, Stack} from "@mui/material";
import Button from "@mui/material/Button";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import DinoDialog from "../../../components/Dialog";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import {useState} from "react";
import RecurrenceSelector from "../../../components/RecurrenceSelector";
import TimeRangePicker from "../../../components/TimeRangePicker3";
import useWorktimeQueries from "../../../hooks/queries/useWorktimeQueries";
import WorktimeCard from "../../../components/WorktimeCard";
import {AddCircleRounded, EditRounded} from "@mui/icons-material";
import Loading from "../../../components/Loading";


const WorkHours = ({userId}) => {
    const [current, setCurrent] = useState({});
    const [popupOpen, setPopupOpen] = useState(false);
    const [editPopupOpen, setEditPopupOpen] = useState(false);
    const [deletePopupOpen, setDeletePopupOpen] = useState(false);
    const [worktimeData, setWorktimeData] = useState({});
    const {useWorktimeUserQuery, createWorktimeMutation, updateWorktimeMutation, deleteWorktimeMutation} = useWorktimeQueries()
    const {data: worktimes, isPending: worktimesLoading} = useWorktimeUserQuery(userId)

    if (worktimesLoading) return <Loading isLoading />
    return <div className="white-card">
        <Typography variant='subtitle1'>
            Munkaidő beállítása
        </Typography>
        <Typography variant='body2' color='#536B74'>
            Add meg mikor dolgozik a kolléga! Figyelj, hogy a
            munkaidők a nyitvatartási időbe essenek bele!
        </Typography>
        <Typography variant='body2' color='#ff0000'>
            Ez a menüpont az adott kolléga elérhetőségi idejét állítja a foglaló felületen, amennyiben a
            szalonod/boltod nyitvatartását szeretnéd módosítani a lábléc szekcióban azt a <a
            href='/opening-hours'>nyitvatartás</a> menüpontban tudod megtenni.
        </Typography>

        <Grid container spacing={2} sx={{mt: 2}}>
            {worktimes?.map((worktime) => (
                <Grid
                    item
                    key={worktime.id}
                    xs={12}      // full width on extra-small screens
                    sm={6}       // 2 per row on small screens
                    md={4}       // 3 per row on medium screens
                    lg={3}       // 4 per row on large screens
                >
                    <WorktimeCard
                        data={worktime.recurrence?.data}
                        startDate={worktime.recurrence?.start_date}
                        startTime={worktime.start}
                        endTime={worktime.end}
                        onEdit={() => {
                            setEditPopupOpen(true)
                            setCurrent(worktime)
                        }}
                        onDelete={() => {
                            setDeletePopupOpen(true)
                            setCurrent(worktime)
                        }}
                    />
                </Grid>
            ))}
        </Grid>

        <Stack direction='row' marginTop={2} justifyContent='end'>
            <Button
                size='large'
                variant='contained'
                endIcon={<SaveRoundedIcon/>}
                onClick={() => {
                    setPopupOpen(true)
                }}>
                Új munkaidő hozzáadása
            </Button>
        </Stack>


        <DinoDialog
            open={popupOpen}
            title='Új munkaidő'
            subtitle=''
            handleClose={() => setPopupOpen(false)}
            actions={<Stack direction='row' spacing={1}>
                <Button
                    variant='outlined'
                    onClick={() => setPopupOpen(false)}>
                    Mégsem
                </Button>
                <Button
                    variant='contained'
                    onClick={() => {
                        createWorktimeMutation.mutate({...worktimeData, user: parseInt(userId)})
                        setPopupOpen(false)
                    }} endIcon={<AddCircleRounded/>}>
                    Hozzáadás
                </Button>
            </Stack>}>
            <div>

                <RecurrenceSelector onChange={data => setWorktimeData(p => ({...p, recurrence: data}))}/>
                <Stack direction='row' spacing={2} sx={{mt: 2}}>
                    <TimeRangePicker onChange={data => setWorktimeData(p => ({...p, ...data}))}/>
                </Stack>
            </div>
        </DinoDialog>

        <DinoDialog
            open={editPopupOpen}
            title='Munkaidő szerkesztése'
            subtitle=''
            handleClose={() => setEditPopupOpen(false)}
            actions={<Stack direction='row' spacing={1}>
                <Button
                    variant='outlined'
                    onClick={() => setEditPopupOpen(false)}>
                    Mégsem
                </Button>
                <Button
                    variant='contained'
                    onClick={() => {
                        updateWorktimeMutation.mutate({id: current.id, data: {...worktimeData, user: parseInt(userId)}})
                        setEditPopupOpen(false)
                    }} endIcon={<EditRounded/>}>
                    Szerkesztés
                </Button>
            </Stack>}>
            <div>
                <RecurrenceSelector data={current?.recurrence?.data} onChange={data => setWorktimeData(p => ({...p, recurrence: data}))}/>
                <Stack direction='row' spacing={2} sx={{mt: 2}}>
                    <TimeRangePicker value={{start: current?.start, end: current?.end}} onChange={data => setWorktimeData(p => ({...p, ...data}))}/>
                </Stack>
            </div>
        </DinoDialog>


        <DinoDialog
            open={deletePopupOpen}
            title='Munkaidő törlése'
            subtitle='Biztosan kitörlöd ezt a munkaidőt? Az ide leadott foglalások nem fognak tölődni!'
            handleClose={() => setDeletePopupOpen(false)}
            actions={<Stack direction='row' spacing={1}>
                <Button
                    variant='outlined'
                    onClick={() => setDeletePopupOpen(false)}>
                    Mégsem
                </Button>
                <Button
                    variant='contained'
                    onClick={() => {
                        deleteWorktimeMutation.mutate(current.id)
                        setDeletePopupOpen(false)
                    }} endIcon={<DeleteRoundedIcon/>}>
                    Törlés
                </Button>
            </Stack>}
        />

    </div>
}

export default WorkHours